import FaIcon from '../utils/FaIcon';
import Clients from '../components/Clients';
import about from "../images/aboutus.png";

const About = () => (
  <div className='about-content'>
    <div className='cards-wrapper flex-wrap'>
      <div className='card'>
        <h3 style={{ color: '#e47931' }}>About Us</h3>
        <h1>Where Expertise Meets Excellence</h1>
        <p>We are a top-tier manufacturer specializing in a variety of Electrical & Instrumentation Control Panels for diverse applications, including automation. Our offerings include PLC-based Electrical Control Panels, Fixed & Draw-out Type MCC/PCC Panels, Instrument Panels, SCADA, and Automatic Power Factor Control Panels. With advanced manufacturing facilities in Vijayapur and Bangalore (India), we are equipped with cutting-edge production tools and testing equipment, providing comprehensive in-house capabilities for Fabrication, Manufacturing, Testing, Erection, and Commissioning of Panels.</p>
      </div>
      <div className='card mini-card-wrapper'>
        <div className='mini-card'>
          <div className='card-icon'>
            <FaIcon icon="clock" />
          </div>
          <h1>{new Date().getFullYear() - 2010}+</h1>
          <span>Years of Expertise</span>
        </div>
        <div className='mini-card'>
          <div className='card-icon'>
            <FaIcon icon="check-circle" />
          </div>
          <h1>252</h1>
          <span>Projects Delivered</span>
        </div>
        <div className='mini-card'>
          <div className='card-icon'>
            <FaIcon icon="industry" />
          </div>
          <h1>180 tons</h1>
          <span>Annual Production Capacity</span>
        </div>
        <div className='mini-card'>
          <div className='card-icon'>
            <FaIcon icon="user-friends" />
          </div>
          <h1>90+</h1>
          <span>Clients Served</span>
        </div>
      </div>
      <div className='card'>
        <h3 style={{ color: '#e47931' }}>Our Vision</h3>
        <p>To be the most trusted and reliable manufacturer of Electrical & Instrumentation Control Panels.
          We aim to achieve this by consistently delivering high-quality products and services that meet or exceed our customers' expectations. We are committed to continuous improvement, innovation, and sustainability in all aspects of our business.</p>
        <br />
        <h3 style={{ color: '#e47931' }}>Our Mission</h3>
        <p>To provide our customers with the best possible solutions for their Electrical & Instrumentation Control Panel needs.
          We strive to achieve this by leveraging our expertise, experience, and advanced technology to deliver high-quality products and services that meet or exceed our customers' expectations. We are committed to building long-term relationships with our customers based on trust, integrity, and mutual respect.</p>
      </div>
      <div className='card width-40'>
        <img src={about} alt="our values" className='center-card' />
      </div>
      <div className='card left-text width-50'>
        <h3 style={{ color: '#e47931', marginLeft: '3rem' }}>Our Values</h3>
        <h1>
          <ul>
            <li><FaIcon iconWidth='3rem' icon='hand-fist' color='#000'/>Integrity</li>
            <li><FaIcon iconWidth='3rem' icon='ranking-star' color='#000'/>Quality</li>
            <li><FaIcon iconWidth='3rem' icon='lightbulb' color='#000'/>Innovation</li>
            <li><FaIcon iconWidth='3rem' icon='users-viewfinder' color='#000'/>Customer Focus</li>
            <li><FaIcon iconWidth='3rem' icon='people-group' color='#000'/>Teamwork</li>
            <li><FaIcon iconWidth='3rem' icon='leaf' color='#000'/>Sustainability</li>
          </ul>
        </h1>
        <p style={{marginLeft:'3rem'}}>We believe that these values are essential to our success and the success of our customers. We are committed to upholding these values in all aspects of our business, from product development to customer service.</p>
      </div>
      <br />
      <div className='card'>
        <h3 style={{ color: '#e47931' }}>Our Commitment</h3>
        <p>To provide our customers with the best possible solutions for their Electrical & Instrumentation Control Panel needs.
        We are committed to continuous improvement, innovation, and sustainability in all aspects of our business. We strive to build long-term relationships with our customers based on trust, integrity, and mutual respect.</p>
        <br/>
        <h3 style={{ color: '#e47931' }}>Our Promise</h3>
        <p>To deliver high-quality products and services that meet or exceed our customers' expectations.
        We are committed to continuous improvement, innovation, and sustainability in all aspects of our business. We strive to build long-term relationships with our customers based on trust, integrity, and mutual respect.</p>
      </div>
    </div>
    <Clients />
  </div>
);

export default About;